document.addEventListener("DOMContentLoaded", () => {
  const gallery = document.querySelector(".expertise-compact_gallery");
  const titles = Array.from(document.querySelectorAll(".expertise-compact_item"));

  if (!gallery || !titles.length) return;

  function updateSectionState() {
    const rect = gallery.getBoundingClientRect();
    const viewportHeight = window.innerHeight;

    const scrollableDistance = rect.height - viewportHeight;
    const scrolled = Math.min(
      Math.max(-rect.top, 0),
      scrollableDistance
    );

    const progress = scrollableDistance > 0
      ? scrolled / scrollableDistance
      : 0;

    const activeIndex = Math.round(progress * (titles.length - 1));

    titles.forEach((title, index) => {
      title.classList.toggle("is-active", index === activeIndex);
    });
  }

  updateSectionState();

  window.addEventListener("scroll", updateSectionState, { passive: true });
  window.addEventListener("resize", updateSectionState);
});
